import type { WForm } from './WidgetPage';

/** Цвет текста на цветном фоне — точно как contrast_for на бэкенде (schemas/widget.py):
 * яркость без гамма-поправки, порог 0,55, тёмный — #1F1F1F. Иначе превью и сайт расходятся. */
export function contrastOn(hex: string) {
  const m = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex);
  if (!m) return '#FFFFFF';
  const [r, g, b] = [m[1], m[2], m[3]].map((x) => parseInt(x, 16) / 255);
  const l = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return l > 0.55 ? '#1F1F1F' : '#FFFFFF';
}

/** «Как это увидят посетители» — живой пример окна и приглашения (экран 7). */
export function WidgetPreview({
  form,
  avatarUrl,
  site,
}: {
  form: WForm;
  avatarUrl: string | null;
  site?: string;
}) {
  const brand = /^#[0-9A-Fa-f]{6}$/.test(form.brand_color) ? form.brand_color : '#1F2937';
  const fg = contrastOn(brand);
  const dark = form.theme === 'dark';
  const name = form.display_name.trim() || 'Ассистент';
  const greet = form.greeting.trim() || 'Здравствуйте! Чем могу помочь?';
  const left = form.position === 'left';
  const ava = avatarUrl ? (
    <img src={avatarUrl} alt="" className="wp-ava" />
  ) : (
    <span className="wp-ava is-letter">{name[0]?.toUpperCase()}</span>
  );

  return (
    <div className="wp">
      <div className="wp-cap">Как это увидят посетители</div>
      <div className="wp-browser">
        <div className="wp-bar">
          <i />
          <i />
          <i />
          <span>{site || 'ваш-сайт.ru'}</span>
        </div>
        <div className="wp-page">
          <div className="wp-lines" aria-hidden="true">
            {Array.from({ length: 9 }, (_, i) => (
              <span key={i} style={{ width: `${90 - ((i * 23) % 45)}%` }} />
            ))}
          </div>
          <div className={`wp-win${dark ? ' is-dark' : ''}${left ? ' is-left' : ''}`}>
            <div className="wp-head">
              {ava}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div className="wp-name">{name}</div>
                <div className="wp-online">на связи</div>
              </div>
              <span aria-hidden="true" className="wp-x">
                ✕
              </span>
            </div>
            <div className="wp-msgs">
              <div className="wp-bot">{greet}</div>
              <div className="wp-me" style={{ background: brand, color: fg }}>
                Сколько стоит диагностика?
              </div>
              <div className="wp-bot">
                Вне гарантии — 900 ₽, по гарантии бесплатно. Записать вас?
              </div>
            </div>
            <div className="wp-input">
              <span>Напишите вопрос…</span>
              <span className="wp-send" style={{ background: brand, color: fg }}>
                ↑
              </span>
            </div>
          </div>
          <span
            className={`wp-launcher${left ? ' is-left' : ''}`}
            style={{ background: brand, color: fg }}
            aria-hidden="true"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M4 5h16v11H8l-4 4z" />
            </svg>
          </span>
        </div>
      </div>
      {form.theme === 'auto' && (
        <div className="v2-xs v2-muted">
          Тема «как на устройстве»: светлое окно, а если на телефоне или компьютере включена тёмная
          тема — тёмное.
        </div>
      )}
      {form.proactive_enabled && (
        <>
          <div className={`wp-invite${dark ? ' is-dark' : ''}`}>
            {form.proactive_show_avatar && ava}
            <div style={{ minWidth: 0 }}>
              <div className="wp-name">{name}</div>
              <div className="wp-invite-text">{greet}</div>
            </div>
          </div>
          <div className="v2-xs v2-muted">
            ↑ Так выглядит приглашение — появится рядом с кнопкой через {form.proactive_delay_sec}{' '}
            сек.
          </div>
        </>
      )}
    </div>
  );
}
